import { HistoryItem } from '../../../common/model/HistoryItem';

export class Comment implements HistoryItem{
    id: number;
    user: string;
    created: Date;
    comment: string;
}